'use strict';

var _vanillaMasker = require('vanilla-masker');

var _vanillaMasker2 = _interopRequireDefault(_vanillaMasker);

require('./input-text.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$$('.ll-input-text').each(function () {
	var $text = $$(this),
	    $input = $text.find('.ll-input-text__input'),
	    $error = $text.find('.ll-input-text__error'),
	    error = null,
	    mask = $text.data('mask');
	switch (mask) {
		case 'cpf':
			(0, _vanillaMasker2.default)($input).maskPattern('999.999.999-99');
			break;
		case 'cnpj':
			(0, _vanillaMasker2.default)($input).maskPattern('99.999.999/9999-99');
			break;
		default:
			break;
	}

	$text[0].validate = function (update) {
		var value = $input.val(),
		    valid = false;

		if (mask == 'cpf') {
			valid = validateCPF(value);
			error = 'Número de CPF inválido';
		} else if (mask == 'cnpj') {
			valid = validateCNPJ(value);
			error = 'Número de CNPJ inválido';
		} else if (mask == 'email') {
			valid = validateEmail(value) && value.length > 0;
			error = 'Email inválido';
		} else {
			valid = value.length > 0;
			error = 'Campo obrigatório';
		}
		if (update) $text[0].update();

		return valid;
	};

	$text[0].val = function () {
		return $input.val();
	};

	$text[0].update = function () {
		var valid = $text[0].validate();

		if (valid) {
			error = null;
			$text.removeClass('is-invalid');
		}

		if (error) {
			$error.html(error);
			$text.addClass('is-invalid');
		}
	};

	$input.on('focus', function (event) {
		return $text.trigger('focus', event);
	});
	$input.on('blur', function (event) {
		return $text.trigger('blur', event);
	});
	$text.on('keyup', function (event) {
		return $text[0].update();
	});
});

function validateEmail(email) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

function validateCPF(c) {
	if ((c = c.replace(/[^\d]/g, "")).length != 11) return false;
	if (c == "00000000000") return false;
	var r;
	var s = 0;
	for (var i = 1; i <= 9; i++) {
		s = s + parseInt(c[i - 1]) * (11 - i);
	}r = s * 10 % 11;
	if (r == 10 || r == 11) r = 0;
	if (r != parseInt(c[9])) return false;
	s = 0;
	for (var i = 1; i <= 10; i++) {
		s = s + parseInt(c[i - 1]) * (12 - i);
	}r = s * 10 % 11;
	if (r == 10 || r == 11) r = 0;
	if (r != parseInt(c[10])) return false;
	return true;
}

function validateCNPJ(c) {
	var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
	if ((c = c.replace(/[^\d]/g, "")).length != 14) return false;
	if (/0{14}/.test(c)) return false;
	for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]) {}
	if (c[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;
	for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]) {}
	if (c[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;
	return true;
}


//////////////////
// WEBPACK FOOTER
// ./src/components/input/input-text.js
// module id = 83
// module chunks = 0